export default __webpack_public_path__ + "static/media/HotelPic3.0756b2a4.jpg";